// cart requirements
export const cartInitialState = {
  reloadCartComponent: false,
};

export const cartReducer = (state, action) => {
  switch (action.type) {
    case "SET_RELOAD_CART_COMPONENT":
      return { ...state, reloadCartComponent: action.payload };
    default:
      return state;
  }
};
